import { ref, watch } from 'vue'
import { useRoute, useNuxtApp } from '#app'
import { useI18n } from '#imports'

export const usePwaUpdate = () => {
  const route = useRoute()
  const { t } = useI18n()
  const { $toast } = useNuxtApp()

  const needsRefresh = ref(false)
  const updateSW = ref(null)

  // 檢查是否在遊戲頁面
  const isGamePage = () => {
    return route.path.startsWith('/game')
  }

  // 顯示更新 Toast
  const showUpdateToast = () => {
    // 使用 $toast 顯示 PWA 更新提示
    $toast.info(t('description.new_version'), {
      autoClose: false,
      closeButton: true,
      position: 'top-center',
      toastId: 'pwa-update',
      onClick: () => {
        updateSW.value?.()
      },
    })
  }

  // 監聽路由變化
  watch(
    () => route.path,
    (newPath, oldPath) => {
      // 從遊戲頁離開且有待顯示的更新提示
      if (!newPath.startsWith('/game') && needsRefresh.value) {
        showUpdateToast()
      }
    }
  )

  // 註冊 Service Worker 更新邏輯
  const registerPwaUpdate = async () => {
    if (typeof window === 'undefined') return

    try {
      const { registerSW } = await import('virtual:pwa-register')

      updateSW.value = registerSW({
        onNeedRefresh() {
          needsRefresh.value = true
          // 如果不在遊戲頁面，立即顯示更新提示
          if (!isGamePage()) {
            showUpdateToast()
          }
        },
        onOfflineReady() {
          console.log('App ready to work offline')
        },
        onRegistered(registration) {
          console.log('SW Registered:', registration)
        },
        onRegisterError(error) {
          console.error('SW registration error', error)
        },
      })
    } catch (error) {
      console.error('Failed to register SW:', error)
    }
  }

  return {
    needsRefresh,
    registerPwaUpdate,
  }
}
